<template>
    <div>
        <v-text-field label="店舗コード"
                      v-bind:value="value"
                      v-on:input="(x) => $emit('input', x)"
                      @blur="onBlur"
                      clearable
                      maxlength="10">
            <template v-slot:append>
                <span class="mx-2 my-code-name" v-if="selected_item != null">{{selected_item.store_name}}</span>
                <v-btn icon color="primary darken-3" style="text-align:center;" small
                       v-on:click="onClick">
                    <v-icon>mdi-menu</v-icon>
                </v-btn>
            </template>
        </v-text-field>

        <v-dialog v-model="dialog" max-width="1000px">
            <v-card>
                <v-card-title class="headline">店舗一覧</v-card-title>
                <v-card-text>
                    
                    <v-container>

                        <v-text-field label="店舗名(あいまい)" v-model="search.store_name" clearable>

                        </v-text-field>
                        <v-text-field label="送信コード または 副送信コード(あいまい)" v-model="search.send_code" clearable>

                        </v-text-field>

                        <v-row>
                            <v-col></v-col>
                            <v-col cols="auto">
                                <span>
                                    対象件数 {{ this.store_list.length }}件
                                </span>
                                <v-btn class="mx-2" color="primary darken-3" dark @click="onSearchStore">検索</v-btn>
                                <v-btn class="mx-2" color="primary darken-3" dark @click="dialog = false">閉じる</v-btn>
                            </v-col>
                        </v-row>
                        

                        <v-simple-table dense height="500px">
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th class="text-left"></th>
                                        <th class="text-left">店舗コード</th>
                                        <th class="text-left">店舗名</th>
                                        <th class="text-left">送信コード</th>
                                        <th class="text-left">副送信コード</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, i) in store_list" :key="i">
                                        <td>
                                            <v-btn class="mx-2" color="primary darken-3" dark v-on:click="onSelectRow(item)">選択</v-btn>
                                        </td>
                                        <td>{{ item.store_code }}</td>
                                        <td>{{ item.store_name }}</td>
                                        <td>{{ item.send_code }}</td>
                                        <td>{{ item.send_sub_code }}</td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>

                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import Vue from 'vue'
    import MyAxios from './MyAxios.vue'
    Vue.mixin(MyAxios);

    export default {
        props: ['value', 'apply_date', 'login_info'],
        watch: {
            value: function (val) {
                if (val !== this.selected_item.store_code) {
                    this.selected_item = null;
                }
            },
            'selected_item.store_name': function(val) {
                console.log(val);
                this.$emit('onChangeStoreName', val);
            }
        },
        data: () => ({
            dialog: false,
            search: {
                store_name: "",
                send_code: "",
                apply_date: "",
                company_code:"",
            },
            store_list: [],
            selected_item: null,
        }),
        methods: {
            onClick() {
                this.dialog = !this.dialog;
            },
            onSelectRow(item) {
                this.dialog = false;
                this.selected_item = item;
                this.$emit('input', item.store_code);
            },
            async onBlur() {
                this.value = this.value.trim();
                await this.getProductItem();

                //if (this.login_info.permission == "3") {
                //    if (this.value != "" && this.dialog == false) {
                //        if (this.login_info.company_code != this.value.substring(0, 3)) {
                //            this.msg_error_dialog_persistent("同一企業内の店舗コードを入力してください");
                //            this.$emit('input', "");
                //        }
                //    }
                //}
            },
            async getProductItem() {
                this.search.store_name = "";
                this.search.send_code = "";
                await this.onSearchStore();
                var flg = false;
                for (var i in this.store_list) {
                    var item = this.store_list[i];
                    if (item.store_code == this.value) {
                        this.selected_item = item;
                        flg = true;
                        this.$emit('input', item.store_code);
                        break;
                    }
                }

                if (this.login_info.permission == "3") {
                    if (this.value != "" && this.dialog == false) {
                        if (!flg) {
                            this.msg_error_dialog_persistent("同一企業内の店舗コードを入力してください");
                            this.$emit('input', "");
                        }
                    }
                }
            },
            async onSearchStore() {
                try {
                    if (this.login_info.permission == "3") {
                        this.search.company_code = this.login_info.company_code;
                    }
                    if (this.apply_date != undefined) {
                        this.search.apply_date = this.apply_date;
                    } else {

                        var today = new Date();
                        var yyyy = String(today.getFullYear());
                        var mm = String((today.getMonth() + 1));
                        var dd = String(today.getDate());
                        mm = ("00" + mm).slice(-2);
                        dd = ("00" + dd).slice(-2);
                        var sysDate = (yyyy + mm + dd);
                        this.search.apply_date = sysDate;
                    }
                    console.log("検索基準日："+this.search.apply_date); 

                    var params = new URLSearchParams();
                    params.append('param', JSON.stringify(this.search));

                    let res = await this.axios_post('/api/CommonComponents/StoreSearch', params);

                    if (res.data.status != "OK") {
                        this.msg_error_dialog(res.data.messages);
                        return;
                    }

                    this.store_list = res.data.store_list;

                } catch (err) {
                    this.msg_error_dialog(err);
                }
            }

        }

    }
</script>

<style>
    .my-code-name{
        padding: 6px 0 8px;
    }
</style>